import { Catalog } from '@vi-succ/products-domain';
import { environment } from '../environments/environment';
import { salesOrgToCountry } from './salesorg-country';

const countryToFilename = new Map<string, string>(
  Object.entries({
    de: 'apps-und-tools',
    ae: 'apps-und-tools',
    am: 'apps-und-tools',
    at: 'apps-und-tools',
    au: 'apps-and-tools',
    be: 'outils-et-applications',
    bg: 'apps-und-tools',
    ca: 'apps-and-tools',
    ch: 'apps-und-tools',
    cn: 'apps-und-tools',
    cz: 'apps-und-tools',
    dk: 'apps-und-tools',
    es: 'apps-tools',
    fi: 'apps-and-tools',
    fr: 'outils-et-applications',
    gb: 'apps-and-tools',
    hr: 'apps-und-tools',
    hu: 'apps-und-tools',
    it: 'applicazioni-e-strumenti',
    lt: 'apps-und-tools',
    lu: 'outils-et-applications',
    lv: 'apps-und-tools',
    nl: 'tools-en-apps',
    pl: 'aplikacje-i-narzedzia',
    ro: 'apps-und-tools',
    rs: 'aplikacije-i-alati',
    se: 'apps-und-tools',
    si: 'apps---tools',
    sk: 'aplikacie-nastroje',
    tr: 'uygulamalar-ve-araclar',
    ua: 'apps-und-tools',
    us: 'apps-and-tools',
    direct: 'apps-and-tools',
  })
);

export class LinkFactory {
  static getOtherAppsLink(country: string): string {
    return countryToFilename.get(country.toLowerCase()) ?? 'apps-and-tools';
  }

  static getOtherAppsLinkForCatalog(catalog: Catalog) {
    const country = salesOrgToCountry(catalog.salesOrg);
    const language = catalog.language.toLowerCase();
    const otherAppsLink = LinkFactory.getOtherAppsLink(country);
    return `${environment.backend.partnerPortalUrl}/${country}/${language}/${otherAppsLink}.html`;
  }

  static getSupportLinkForCatalog(catalog: Catalog, loggedIn: boolean) {
    const country = salesOrgToCountry(catalog.salesOrg);
    const language = catalog.language.toLowerCase();
    if (loggedIn) {
      return `${environment.backend.partnerPortalUrl}/${country}/${language}/support/faq/vi_parts.html`;
    } else {
      return `${environment.backend.partnerPortalUrl}/content/dam/partnerportal/${country}/${language}/support/ViParts_FAQs.pdf/_jcr_content/renditions/original./ViParts_FAQs.pdf`;
    }
  }

  static vibooksLink(catalog: Catalog, materialNumber: string) {
    const country = salesOrgToCountry(catalog.salesOrg);
    const language = catalog.language.toLowerCase();
    return `${environment.backend.vibooksUrl}/${country}/${language}?query=${materialNumber}`;
  }
}
